import { z } from 'zod';
import { TextElementSchema } from '@/components/canvas/elements/text/schema';
import { ImageElementSchema } from '@/components/canvas/elements/image/schema';
import { TableElementSchema } from '@/components/canvas/elements/table/schema';
import { ChartElementSchema } from '@/components/canvas/elements/chart/schema';
import { LineElementSchema } from '@/components/canvas/elements/shape/line/schema';
import { RectElementSchema } from '@/components/canvas/elements/shape/rect/schema';
import { CircleElementSchema } from '@/components/canvas/elements/shape/circle/schema';
import { TriangleElementSchema } from '@/components/canvas/elements/shape/triangle/schema';
import { VectorElementSchema } from '@/components/canvas/elements/shape/vector/schema';
import { FreehandElementSchema } from '@/components/canvas/elements/shape/freehand/schema';
import { GroupElementSchema } from '@/components/canvas/elements/group/schema';

export const ElementSchema = z.discriminatedUnion('type', [
  TextElementSchema,
  ImageElementSchema,
  TableElementSchema,
  ChartElementSchema,
  LineElementSchema,
  RectElementSchema,
  CircleElementSchema,
  TriangleElementSchema,
  VectorElementSchema,
  FreehandElementSchema,
  GroupElementSchema,
]);
